import { UntypedFormControl } from '@angular/forms';

// Control capable of storing warnings, so that they can be used for visual purposes
export class WarningFormControl extends UntypedFormControl {
  private _warnings: Record<string, string> | null = null;

  getWarnings(): Record<string, string> | null {
    return this._warnings;
  }

  setWarnings(warnings: Record<string, string> | null) {
    this._warnings = warnings;
  }

  clearWarnings(): void {
    this._warnings = null;
  }

  hasWarnings(): boolean {
    return this._warnings !== null && Object.keys(this._warnings).length > 0;
  }
}
